module.exports = __webpack_public_path__ + "img/el-kios-02.5005be80.jpg";